import { HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ToastService } from "@core/toast";
import { Actions, createEffect, CreateEffectMetadata, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { RemitterService } from "../services/remitter.service";
import { loadRemitters, loadRemittersFailure, loadRemittersSuccess } from "./remitter.actions";

@Injectable()
export class RemitterEffects {
	private readonly actions$ = inject(Actions);
	private readonly remitterService = inject(RemitterService);
	private readonly toastService = inject(ToastService);

	public loadRemitters$: CreateEffectMetadata = createEffect(() =>
		this.actions$.pipe(
			ofType(loadRemitters),
			switchMap((action: ReturnType<typeof loadRemitters>) => {
				return this.remitterService.loadRemitters(action.serviceEntityId, action.clientId).pipe(
					map((remitters) => loadRemittersSuccess({ remitters })),
					catchError((error: HttpErrorResponse) => of(loadRemittersFailure({ error })))
				);
			})
		)
	);
}
